import { useState, type FormEvent } from "react";
import { loginRequest } from "./publicationsAdminApi";
import styles from "./PublicationsAdmin.module.css";

type LoginFormProps = {
  onAuthenticated: (token: string) => void;
};

export const LoginForm = ({ onAuthenticated }: LoginFormProps) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setIsSubmitting(true);
    setError(null);
    try {
      const token = await loginRequest(password);
      onAuthenticated(token);
    } catch {
      setError("Incorrect password");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form className={styles.loginForm} onSubmit={handleSubmit}>
      <h1>Publications admin</h1>
      <label htmlFor="admin-password">Password</label>
      <input
        id="admin-password"
        type="password"
        value={password}
        onChange={(event) => setPassword(event.target.value)}
        autoComplete="current-password"
      />
      {error !== null && <p className={styles.error}>{error}</p>}
      <button type="submit" disabled={isSubmitting}>
        {isSubmitting ? "Signing in…" : "Sign in"}
      </button>
    </form>
  );
};
